function Icon({ name, className = "" }) {
  const baseClass = `dana-icon ${className}`.trim();

  switch (name) {
    case "layout":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="3" y="4" width="8" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <rect x="13" y="4" width="8" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <rect x="3" y="13" width="8" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <rect x="13" y="13" width="8" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      );
    case "templateDoc":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M7 3.8h7.2l2.8 2.8v11.6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-12.4a2 2 0 0 1 2-2Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path d="M14.2 3.8v2a1 1 0 0 0 1 1h1.8" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          <path d="M8.4 11.3h5.8M8.4 14.7h7.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "bell":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6.8 16.6h10.4l-1.1-1.8v-4.1a4.1 4.1 0 0 0-8.2 0v4.1l-1.1 1.8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          <path d="M10 18.7a2 2 0 0 0 4 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "settings":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M13.7 3.8a1 1 0 0 0-1-.8h-1.4a1 1 0 0 0-1 .8l-.3 1.6a6.8 6.8 0 0 0-1.4.6L7 4.9a1 1 0 0 0-1.3.1L4.7 6a1 1 0 0 0 .1 1.3l1.1 1.2a6.8 6.8 0 0 0-.6 1.4l-1.6.3a1 1 0 0 0-.8 1v1.4a1 1 0 0 0 .8 1l1.6.3c.1.5.3 1 .6 1.4l-1.1 1.2a1 1 0 0 0-.1 1.3l1 1a1 1 0 0 0 1.3.1l1.2-1.1c.4.2.9.4 1.4.6l.3 1.6a1 1 0 0 0 1 .8h1.4a1 1 0 0 0 1-.8l.3-1.6c.5-.1 1-.3 1.4-.6l1.2 1.1a1 1 0 0 0 1.3-.1l1-1a1 1 0 0 0-.1-1.3l-1.1-1.2c.2-.4.4-.9.6-1.4l1.6-.3a1 1 0 0 0 .8-1v-1.4a1 1 0 0 0-.8-1l-1.6-.3a6.8 6.8 0 0 0-.6-1.4l1.1-1.2a1 1 0 0 0 .1-1.3l-1-1a1 1 0 0 0-1.3-.1L15.4 6c-.4-.2-.9-.4-1.4-.6l-.3-1.6Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <circle cx="12" cy="12" r="2.7" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      );
    case "chat":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5 6.5A2.5 2.5 0 0 1 7.5 4h9A2.5 2.5 0 0 1 19 6.5v6A2.5 2.5 0 0 1 16.5 15h-4.6L8 18v-3H7.5A2.5 2.5 0 0 1 5 12.5v-6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
      );
    case "help":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="8.2" stroke="currentColor" strokeWidth="1.8" />
          <path d="M9.7 9.3a2.7 2.7 0 1 1 4.4 2.1c-.9.7-1.6 1.2-1.6 2.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <circle cx="12" cy="16.9" r="1" fill="currentColor" />
        </svg>
      );
    case "helpSolid":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="8.2" fill="currentColor" opacity="0.18" />
          <circle cx="12" cy="12" r="8.2" stroke="currentColor" strokeWidth="2.2" />
          <path d="M9.6 9.2a2.8 2.8 0 1 1 4.8 2c-1 .8-1.7 1.4-1.7 2.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
          <circle cx="12" cy="17.1" r="1.2" fill="currentColor" />
        </svg>
      );
    case "user":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="8" r="3.3" stroke="currentColor" strokeWidth="1.8" />
          <path d="M5.5 18.5a6.5 6.5 0 0 1 13 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "userSolid":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 5.1a3.7 3.7 0 1 1 0 7.4 3.7 3.7 0 0 1 0-7.4Z" fill="currentColor" />
          <path d="M4.7 18.9c.7-3 3.4-4.9 7.3-4.9 4 0 6.6 1.9 7.3 4.9a.75.75 0 0 1-.73.92H5.43a.75.75 0 0 1-.73-.92Z" fill="currentColor" />
        </svg>
      );
    case "home":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4.5 10.2 12 4.5l7.5 5.7v8.8a.5.5 0 0 1-.5.5h-5.1v-6h-3.8v6H5a.5.5 0 0 1-.5-.5v-8.8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
      );
    case "flow":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="6" cy="6" r="2.6" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="18" cy="12" r="2.6" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="6" cy="18" r="2.6" stroke="currentColor" strokeWidth="1.8" />
          <path d="M8.6 7.3 15.4 10.7M8.6 16.7l6.8-3.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "database":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <ellipse cx="12" cy="6.5" rx="6.5" ry="2.8" stroke="currentColor" strokeWidth="1.8" />
          <path d="M5.5 6.5v4.3c0 1.5 2.9 2.8 6.5 2.8s6.5-1.3 6.5-2.8V6.5M5.5 10.8v4.3c0 1.5 2.9 2.8 6.5 2.8s6.5-1.3 6.5-2.8v-4.3" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      );
    case "timeline":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 6.2v11.6M18 6.2v11.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <circle cx="6" cy="8" r="2" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="18" cy="16" r="2" stroke="currentColor" strokeWidth="1.8" />
          <path d="M8 8h2M14 12h2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "signal":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="1.8" fill="currentColor" />
          <path d="M8.2 8.2a5.4 5.4 0 0 1 7.6 0M5.5 5.5a9.2 9.2 0 0 1 13 0M8.2 15.8a5.4 5.4 0 0 1 7.6 0M5.5 18.5a9.2 9.2 0 0 1 13 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "folder":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M3.8 8.2h6l1.7-2h8.7v10.9a2 2 0 0 1-2 2H5.8a2 2 0 0 1-2-2V8.2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
      );
    case "chart":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5 19.2h14M7.5 16V9.5M12 16V6.2M16.5 16v-4.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "mail":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="4" y="6.5" width="16" height="11" rx="2" stroke="currentColor" strokeWidth="1.8" />
          <path d="m5.7 8.2 6.3 4.8 6.3-4.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "sms":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5 6.5A2.5 2.5 0 0 1 7.5 4h9A2.5 2.5 0 0 1 19 6.5v6A2.5 2.5 0 0 1 16.5 15h-4.6L8 18v-3H7.5A2.5 2.5 0 0 1 5 12.5v-6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
      );
    case "phone":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M8.5 4.8c.3-.6 1.1-.8 1.7-.4l1.8 1.2c.6.4.7 1.2.3 1.8l-1 1.4a12.3 12.3 0 0 0 4.1 4.1l1.4-1c.6-.4 1.4-.3 1.8.3l1.2 1.8c.4.6.2 1.4-.4 1.7l-1.6.9a3.4 3.4 0 0 1-3.2.1 16.2 16.2 0 0 1-7.3-7.3 3.4 3.4 0 0 1 .1-3.2l1-1.6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
      );
    case "key":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="8.2" cy="12" r="3.4" stroke="currentColor" strokeWidth="1.8" />
          <path d="M11.6 12h7.2M16.7 12v2.6M14.4 12v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "users":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="9" cy="9" r="2.8" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="16.6" cy="10.1" r="2.2" stroke="currentColor" strokeWidth="1.8" />
          <path d="M4.5 18.4a4.6 4.6 0 0 1 9.2 0M13.6 18.4a3.6 3.6 0 0 1 6.1-2.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "addressBook":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="6.2" y="4.2" width="11.8" height="15.6" rx="2" stroke="currentColor" strokeWidth="1.8" />
          <path d="M9.8 9.3h5.7M9.8 12.2h5.7M9.8 15.1h4.1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M6.2 7.4h-1.3M6.2 11.1h-1.3M6.2 14.8h-1.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "signature":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M3.8 17.8h6.4l6.5-6.5a2.2 2.2 0 1 0-3.1-3.1L7 14.8v3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          <path d="M12.9 7.9 16 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "check":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="8.2" stroke="currentColor" strokeWidth="1.8" />
          <path d="m8.3 12.1 2.4 2.4 5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "close":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="8.2" stroke="currentColor" strokeWidth="1.8" />
          <path d="m9.2 9.2 5.6 5.6m0-5.6-5.6 5.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "x":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="m6.5 6.5 11 11m0-11-11 11" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        </svg>
      );
    case "clock":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="8.2" stroke="currentColor" strokeWidth="1.8" />
          <path d="M12 7.8v4.5l2.9 1.9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "alertTriangle":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M12 4.5 20.1 18a1.2 1.2 0 0 1-1 1.8H4.9a1.2 1.2 0 0 1-1-1.8L12 4.5Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path d="M12 9v5.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <circle cx="12" cy="16.9" r="1.1" fill="currentColor" />
        </svg>
      );
    case "plus":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case "minus":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case "zoomIn":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="10.5" cy="10.5" r="5.6" stroke="currentColor" strokeWidth="1.8" />
          <path d="M10.5 8v5M8 10.5h5M15.2 15.2l4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "zoomOut":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="10.5" cy="10.5" r="5.6" stroke="currentColor" strokeWidth="1.8" />
          <path d="M8 10.5h5M15.2 15.2l4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "trash":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5.8 7.2h12.4M9.4 7.2V5.6h5.2v1.6M8.4 10v7.2M12 10v7.2M15.6 10v7.2" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
          <path d="M7.4 7.2l.8 11a2 2 0 0 0 2 1.8h3.6a2 2 0 0 0 2-1.8l.8-11" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
        </svg>
      );
    case "rotateRight":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M18.2 10.2V5.8h-4.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M18 10.2a6.8 6.8 0 1 0 1 3.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "rotateLeft":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5.8 10.2V5.8h4.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6 10.2a6.8 6.8 0 1 1-1 3.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "sliders":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5 6h14M5 12h14M5 18h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <circle cx="9" cy="6" r="2" fill="white" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="15" cy="12" r="2" fill="white" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="11" cy="18" r="2" fill="white" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      );
    case "edit":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M4.8 16.7v2.5h2.5l8.6-8.6-2.5-2.5-8.6 8.6Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="m12.8 8.1 2.5 2.5M15 5.9l2.2-2.2 2.5 2.5-2.2 2.2"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "copy":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="8.2" y="8.2" width="10.4" height="10.4" rx="2" stroke="currentColor" strokeWidth="1.8" />
          <rect x="5.4" y="5.4" width="10.4" height="10.4" rx="2" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      );
    case "download":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 4.5v9.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="m8.7 10.7 3.3 3.3 3.3-3.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M5.2 18.2h13.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "eye":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M3.7 12s3.1-5 8.3-5 8.3 5 8.3 5-3.1 5-8.3 5-8.3-5-8.3-5Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <circle cx="12" cy="12" r="2.3" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      );
    case "moreVertical":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="6" r="1.8" fill="currentColor" />
          <circle cx="12" cy="12" r="1.8" fill="currentColor" />
          <circle cx="12" cy="18" r="1.8" fill="currentColor" />
        </svg>
      );
    case "chevronRight":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="m9 6 6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "chevronLeft":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="m15 6-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "chevronDown":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "menu":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4.8 7.2h14.4M4.8 12h14.4M4.8 16.8h14.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case "pageFirst":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M7.2 6.2v11.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="m16.6 6.6-6.1 5.4 6.1 5.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "pageLast":
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M16.8 6.2v11.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="m7.4 6.6 6.1 5.4-6.1 5.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    default:
      return (
        <svg className={baseClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      );
  }
}

export default Icon;
